// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:13:17.966Z
// Property: The Quinn at Westchase (ID: 6767906449166817)
// Collections: 30 amenities, 7 floorplans (live), 14 photos, 36 POIs, 4 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6767906449166817",
  "property_external_id": "5586676",
  "property_zillow_url": "https://www.zillow.com/homedetails/2101-Hayes-Rd-APT-202-Houston-TX-77077/2087428264_zpid/",
  "property_apartments_url": "https://www.apartments.com/the-quinn-at-westchase-houston-tx/zhlrrgy/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Quinn+at+Westchase/data=!4m2!3m1!1s0x0:0xdf0e5deedb71d1bf?sa=X&ved=2ahUKEwivpemV0LySAxXkd0EAHQIvDYgQ_BJ6BAgPEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/company/quine-&-associates-inc-",
  "property_hubspot_id": "43833693005",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-quinn-at-westchase",
  "property_name": "The Quinn at Westchase",
  "property_website_url": "https://www.thequinnatwestchase.com/",
  "property_domain": "https://www.thequinnatwestchase.com/",
  "property_address": "2101 Hayes Road",
  "property_full_address": "2101 Hayes Rd, Houston, TX 77077",
  "property_address_1": "2101 Hayes Rd",
  "property_address_2": null,
  "property_address_city": "Houston",
  "property_address_state": "TX",
  "property_address_zip_full": "77077-6954",
  "property_address_zip": "77077",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Briar Forest",
  "property_address_latitude": "29.7433663",
  "property_address_longitude": "-95.5755119",
  "property_email": "quinnatwestchase@rrliving.com",
  "property_phone": "(832) 925-8518",
  "property_call_tracking_phone": "832-510-8533",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to The Quinn at Westchase, where community and comfort intertwine. Choose from spacious one, two, or three-bedroom floor plans, and enjoy amenities like a refreshing pool, playful dog park, and serene picnic area. Unwind on your private balcony and feel right at home—your perfect sanctuary awaits in Houston!",
  "property_long_description": "Welcome to The Quinn at Westchase, your ideal urban oasis nestled in the heart of Houston, TX. Our charming apartment community boasts a variety of spacious floor plans, featuring one, two, and three-bedroom layouts designed to meet your needs. Each home is thoughtfully equipped with modern amenities, including air conditioning, ceiling fans, and stylish finishes, ensuring you enjoy comfort at every turn.\n\nAt The Quinn, we believe in elevating your living experience with an array of exceptional amenities. Take a refreshing dip in our sparkling pool, unwind on the sundeck, or host delightful gatherings in our inviting picnic area. For family fun, let the kids explore our playground while you enjoy a leisurely afternoon in the lounge or read a book on your private balcony or patio. Our community is pet-friendly, featuring a designated dog park for your furry friends.\n\nConvenience is key at The Quinn, with controlled access and on-site property management to offer peace of mind. With public transportation options nearby and on-site maintenance, getting around and managing tasks has never been easier. Stay connected with high-speed internet access, and enjoy the luxury of a dishwasher and washer/dryer hookups in your home.\n\nExperience the perfect blend of comfort, community, and convenience at The Quinn at Westchase. Find your new home today - browse our availability or schedule a tour to visit our vibrant community! We can’t wait to welcome you home.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089c-1456-7175-9570-72352c78d5d4.webp",
  "property_featured_image_media": {
    "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas on a sunny day.",
    "public_id": "019d089c-1456-7175-9570-72352c78d5d4",
    "storage_key": "property/6767906449166817/019d089c-1456-7175-9570-72352c78d5d4.webp",
    "width": 2500,
    "height": 1667
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "368",
  "property_year_built": "1978",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "58.15217391304348",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs welcome. No breed or weight restrictions. Maximum 2 pets per unit.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://9259692.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://thequinnatwestchase.loftliving.com/login",
  "property_apply_now_url": "https://9259692.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089c-24af-72bd-bb1f-a2514479af6e.webp",
  "property_primary_logo_media": {
    "alt_text": "The Quinn at Westchase logo.",
    "public_id": "019d089c-24af-72bd-bb1f-a2514479af6e",
    "storage_key": "property/6767906449166817/019d089c-24af-72bd-bb1f-a2514479af6e.webp",
    "width": 640,
    "height": 290
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019e1dd4-366f-702d-902c-c870fcd011c4.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Quinn at Westchase logo",
    "public_id": "019e1dd4-366f-702d-902c-c870fcd011c4",
    "storage_key": "property/6767906449166817/019e1dd4-366f-702d-902c-c870fcd011c4.webp",
    "width": 1920,
    "height": 870
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089c-3f99-7303-94e9-0195c881279e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Quinn at Westchase logo",
    "public_id": "019d089c-3f99-7303-94e9-0195c881279e",
    "storage_key": "property/6767906449166817/019d089c-3f99-7303-94e9-0195c881279e.webp",
    "width": 640,
    "height": 290
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089c-49e0-734a-9925-b104334380c3.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Quinn at Westchase logo",
    "public_id": "019d089c-49e0-734a-9925-b104334380c3",
    "storage_key": "property/6767906449166817/019d089c-49e0-734a-9925-b104334380c3.webp",
    "width": 640,
    "height": 290
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#124556",
  "property_secondary_color": "#c5cb50",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "380 - 1150",
  "property_sqft_min": "380",
  "property_sqft_max": "1150",
  "property_price_range": "641 - 1517",
  "property_price_min": "641",
  "property_price_max": "1517",
  "property_available_units": 154,
  "property_facebook_url": "https://www.facebook.com/TheQuinnWestchase",
  "property_instagram_url": "https://www.instagram.com/thequinnwestchase/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJPZq7B7ncQIYRv9Fx2-5dDt8",
  "property_youtube_url": "https://www.youtube.com/watch?v=_71g9ppGAYo",
  "property_yelp_url": "https://www.yelp.com/biz/westchase-ranch-houston",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Quinn at Westchase",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community Today",
  "property_home_amenities_blurb": "<p>The Sweet Life: The Quinn at Westchase Apartments. Everyone loves a good makeover story, and our apartment homes are giving this bustling business district a story for ages. With amazing renovations underway and a new management team focused on resident satisfaction, The Quinn at Westchase is the perfect place to call home!!</p>\n<p>Choose from an extensive selection of studio, one, two, and three-bedroom floor plans available in two finish options: classic and renovated.</p>\n<p>To make life easy and comfortable, Our apartment homes offer a wonderful host of amenities our residents are free to enjoy. Their list includes two sparkling swimming pools, multiple tennis courts, and an expansive courtyard with a brand-new dog park and an outdoor kitchen. The cherry on top is our fantastic staff working hard to ensure your needs are met.</p>\n<p>The Quinn at Westchase boasts a prime location in the Westchase District with easy access to some of the hottest attractions in Westside Houston, including Houston Galleria, Terry Hershey Park, and Memorial City Mall. Top it all with our proximity to major transit arteries like I-10, and you can reach any destination fast and easily.</p>",
  "property_home_floorplans_blurb": "<p>At The Quinn at Westchase in Houston, TX, stylish living awaits with thoughtfully designed floor plans. Choose from trendy studio and one, spacious two, or family-friendly three-bedroom apartments. Each layout reflects modern charm, ensuring you find the perfect home. Browse our available options today and start your next chapter with us!</p>",
  "property_home_gallery_blurb": "<p>At The Quinn at Westchase in Houston, TX, vibrant living meets comfort. Imagine unwinding by our pool, enjoying a sunny picnic, or playing fetch in the dog park. With tailored floor plans, top-notch amenities and a welcoming community, your ideal home is just a picture away. Picture yourself living here!</p>",
  "property_home_neighborhood_blurb": "At The Quinn at Westchase, spacious one-, two-, and three-bedroom apartments await you in vibrant Houston, TX. Nestled near top-notch amenities like the Houston Community College campuses, parks like Arthur Storey and Terry Hershey, and fitness centers, enjoy a connected lifestyle that keeps you engaged every day.",
  "property_home_reviews_blurb": "At The Quinn at Westchase, our residents rave, “We absolutely love our apartment!” Nestled in Houston, TX, our community offers comfort, convenience, and a seamless moving experience, thanks to our dedicated staff. With everything you need nearby and a peaceful atmosphere, your perfect home awaits! See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p>At The Quinn at Westchase, spacious studio, one-, two-, and three-bedroom apartments await you in vibrant Houston, TX. Nestled near top-notch amenities like the Houston Community College campuses, parks like Arthur Storey and Terry Hershey, and fitness centers, enjoy a connected lifestyle that keeps you engaged every day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At The Quinn at Westchase in Houston, TX, our vibrant community is designed for your lifestyle. With spacious studio, one, two, and three-bedroom floor plans, indulge in amenities like a refreshing pool, dog park, sundeck, and relaxing picnic area. Comfortable living awaits—immerse yourself in luxury today!</p>",
  "property_applynow_blurb": "Welcome to The Quinn at Westchase, where comfort meets convenience in the heart of Houston, TX. Choose from spacious one, two, or three-bedroom floor plans, and enjoy amenities like a refreshing pool, dog park, and cozy lounge. Your ideal home awaits—lease online and embrace a vibrant lifestyle today!",
  "property_contactus_blurb": "At The Quinn at Westchase in Houston, TX, find the perfect space with our diverse floor plans, including one, two, and three-bedroom layouts. Embrace comfort and style in a community designed for modern living. Have questions? Contact our leasing team today and start your journey to your new home!",
  "property_faqs_blurb": "At The Quinn at Westchase in Houston, TX, we cater to every lifestyle with our diverse range of floor plans, including one, two, and three-bedroom apartments. Have questions? Visit our FAQs page for all the information you need about our vibrant community and living experience that awaits you.",
  "property_floorplans_blurb": "<p>At The Quinn at Westchase in Houston, TX, stylish living awaits with thoughtfully designed floor plans. Choose from trendy studio and one, spacious two, or family-friendly three-bedroom apartments. Each layout reflects modern charm, ensuring you find the perfect home. Browse our available options today and start your next chapter with us!</p>",
  "property_gallery_blurb": "<p>At The Quinn at Westchase in Houston, TX, vibrant living meets comfort. Imagine unwinding by our pool, enjoying a sunny picnic, or playing fetch in the dog park. With tailored floor plans, top-notch amenities and a welcoming community, your ideal home is just a picture away. Picture yourself living here!</p>",
  "property_interactivemap_blurb": "Welcome to The Quinn at Westchase, where comfort meets convenience in Houston, TX. Choose from spacious one, two, or three-bedroom apartments featuring modern amenities like a refreshing pool, dog park, and inviting lounge. Take control of your living experience with our interactive community map—your new home awaits!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At The Quinn at Westchase in Houston, TX, our vibrant community thrives on friendships! Choose from spacious one, two, or three-bedroom floor plans that suit your lifestyle. Share the joy of living here—refer a friend today and create lasting memories with great neighbors in a fantastic environment!",
  "property_residentaccess_blurb": "At The Quinn at Westchase in vibrant Houston, TX, our diverse floor plans—one, two, and three bedrooms—offer the perfect space to call home. Seamlessly manage your apartment life with our resident portal—pay rent, schedule maintenance, and enjoy hassle-free living at your fingertips. Login now and take control!",
  "property_reviews_blurb": "At The Quinn at Westchase, our residents cherish the comfort of a pest-free environment and the warm support from our team. One thrilled tenant shared, \"Ms. Marlene is such a wonderful person... she made sure our moving journey went smoothly.\" Experience the welcoming atmosphere and vibrant community today!",
  "property_created_at": "1762356784097",
  "property_scheduletour_blurb": "At The Quinn at Westchase in Houston, TX, our thoughtfully designed one, two, and three-bedroom apartments cater to your lifestyle. Experience a vibrant community atmosphere, and envision your next home among modern comforts. Ready to be inspired? Schedule a tour today and hear firsthand from our delighted residents!",
  "property_thankyou_blurb": "Thank you for reaching out! At The Quinn at Westchase in Houston, TX, our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—offer the perfect fit for every lifestyle. A team member will be in touch soon to help you find your ideal home. Stay tuned!",
  "property_virtualtours_blurb": "Step into The Quinn at Westchase, where stylish living meets modern comfort in Houston, TX. Choose from one, two, or three-bedroom floor plans designed for your lifestyle. Ready to envision your new home? Take a virtual tour of our vibrant community and see why you'll love living here!",
  "property_copyright": "2025 All Rights Reserved. The Quinn at Westchase",
  "property_seo_title_home": "The Quinn at Westchase |  Apartments in Houston, TX",
  "property_seo_description_home": "Welcome to The Quinn at Westchase! Discover spacious apartments with great amenities, including a pool, dog park, and picnic area in Houston!",
  "property_seo_title_floorplans": "Floor Plans | Houston, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Quinn at Westchase in Houston, TX! Choose from stylish one, two, or three-bedroom floor plans to suit your lifestyle.",
  "property_seo_title_amenities": "Amenities | Houston, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort and convenience at The Quinn at Westchase in Houston, TX. Enjoy a pool, dog park, and cozy apartments—your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Houston, TX",
  "property_seo_description_gallery": "Picture life at The Quinn at Westchase in Houston! From one to three-bedroom plans, enjoy a pool, playground, and dog park in a vibrant community.",
  "property_seo_title_virtualtours": "Virtual Tours | The Quinn at Westchase Apartments",
  "property_seo_description_virtualtours": "Experience The Quinn at Westchase in Houston, TX! Take a virtual tour of our stylish one, two, and three-bedroom apartments. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | The Quinn at Westchase Apartments",
  "property_seo_description_interactivemap": "Navigate your way to The Quinn at Westchase in Houston! Use our interactive map to find your perfect 1-3 bedroom apartment with fantastic amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Houston, TX",
  "property_seo_description_neighborhood": "Experience the vibrant neighborhood surrounding The Quinn at Westchase in Houston. Uncover local gems and explore the best spots just steps from home!",
  "property_seo_title_contact": "Contact Us | The Quinn at Westchase",
  "property_seo_description_contact": "Connect with The Quinn at Westchase in Houston! Whether you're seeking one, two, or three-bedroom homes, our team is ready to assist with all your inquiries.",
  "property_seo_title_faqs": "FAQs | Apartments in Houston, TX",
  "property_seo_description_faqs": "Curious about life at The Quinn at Westchase? Our FAQs unveil everything from floor plans to amenities—your ideal Houston home awaits! Click to learn more.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Houston, TX",
  "property_seo_description_reviews": "Uncover the experiences of The Quinn at Westchase residents! Dive into their stories of comfort, community, and convenience in vibrant Houston, TX.",
  "property_seo_title_applynow": "Apply Now | Apartments in Houston, TX",
  "property_seo_description_applynow": "Welcome to The Quinn at Westchase! Discover spacious 1, 2, & 3-bedroom apartments with great amenities. Lease your perfect home online today!",
  "property_seo_title_residentaccess": "Resident Access | The Quinn at Westchase",
  "property_seo_description_residentaccess": "Unlock the convenience of The Quinn at Westchase! Log in to your resident portal for seamless rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | The Quinn at Westchase",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to The Quinn at Westchase in Houston and share the joy of vibrant living in our welcoming community.",
  "property_seo_title_scheduletour": "Schedule a Tour | The Quinn at Westchase",
  "property_seo_description_scheduletour": "Experience life at The Quinn at Westchase in Houston, TX. Schedule a tour today and see your future home filled with luxury and vibrant community living!",
  "property_seo_title_privacy": "Privacy Policy | The Quinn at Westchase",
  "property_seo_description_privacy": "At The Quinn at Westchase, your privacy matters. Discover how we keep your info safe while you enjoy luxury living in Houston.",
  "property_seo_title_accessibility": "Website Accessibility | The Quinn at Westchase",
  "property_seo_description_accessibility": "At The Quinn at Westchase in Houston, we prioritize digital inclusion, ensuring everyone can enjoy our community. Embrace accessible living—join us today!",
  "property_seo_title_sitemap": "Sitemap | The Quinn at Westchase",
  "property_seo_description_sitemap": "Uncover a world of luxury living at The Quinn at Westchase in Houston, TX. View our sitemap to find your perfect home in our vibrant community today!",
  "property_seo_title_thankyou": "Thank You | The Quinn at Westchase",
  "property_seo_description_thankyou": "Thank you for reaching out to The Quinn at Westchase! Our team is excited to connect and help you find your ideal Houston home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Houston, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293637987",
  "amenities": [
    {
      "id": "custom_79936b57-2aff-4c02-aa8c-633d0f78c85a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "NEW Flexible Payment Option",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3f750fbd-f1c1-4ab4-8ced-15f7e2d4f3da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa3bcd30-9dd2-4522-8f8a-ced0b70eabd8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bef089df-5905-430a-90cf-f31dbfb87a39",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_999cc227-f251-4b38-897d-b5826738409e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Houston Housing Authority Partners",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b1ac4cf1-fe4f-412b-8550-2b7893dcb765",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Sport Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b07fac11-2c0f-42ff-9b11-edf733c696d9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Lounge Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ebf16ea6-fa2d-4856-aaab-d1453b7ce865",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic Area with Barbecue Grills",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3425d339-cba1-4efd-bfa6-0d4e4fa9183d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_82e1a9b6-08a4-43a4-91bd-2b45e61e8f02",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "On‑Site Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5dba551c-b91a-4784-abfd-8ab053c1fe4f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Guest Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5183efec-f51e-4152-9f84-529abe30f04f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Thoughtful Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bfbe27cb-2801-4420-a1e8-9703f2a49af0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Off‑Street Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ead1c4a9-8d3a-471f-b378-2707f0704aa8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Great Nearby Shopping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa589b08-9993-46ad-928d-173b0fff2f34",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Access to Public Transportation",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4b2fc20a-673b-4901-9ffe-a0b43d5921a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to Freeways",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3d998bc3-863a-438e-9eb2-a6be645ddb6e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Public Parks Nearby",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_00584058-77a8-4bfc-95b8-e8a8b4d98baf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Online Resident Portal",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c44f797b-466e-42c9-ab15-e70ff73dc11b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "On‑Site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6ea359ea-b9c1-4e0f-a12e-e4a6f916c751",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "On‑Site Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d7acaba6-43ee-49b7-a7b2-ad9a8bfcec47",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Habla Español",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e25101c7-8ec6-407f-befe-d92ef020e9a0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer Hookups in Unit*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e769a46-236a-4414-8f05-0f06693a01f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious 9‑Foot Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_558d7e0f-ccde-4a42-91cf-706736beb280",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood‑Style Plank Flooring*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_452abef8-abc0-4de6-b032-60ed20566089",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Central A/C & Heating*",
      "amount": "false",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b7d68e1e-c924-4138-9084-c2a8a97029c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Patio/Balcony*",
      "amount": "false",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_33c58d26-e38e-4663-bd5f-7196eacf46e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bfbd6cf2-af5c-42ba-a746-6ed6022c8f46",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "High‑Speed Internet Access*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_54b73638-5526-4222-9eef-339059a3d5e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeted Floors*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ddef0d3-eebd-4259-bafe-c7f63c4b2404",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace*",
      "amount": "false",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_86ab79f0-acf8-46c2-9c4c-8bdb39f26eca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089c-1456-7175-9570-72352c78d5d4.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas on a sunny day.",
        "public_id": "019d089c-1456-7175-9570-72352c78d5d4",
        "storage_key": "property/6767906449166817/019d089c-1456-7175-9570-72352c78d5d4.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge chairs and shaded areas.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3aa20e78-db17-4183-a1ba-3eabc550478d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019f858d-cdcf-77c4-8034-2baea37506c2.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstands, dresser, and a window with blinds.",
        "public_id": "019f858d-cdcf-77c4-8034-2baea37506c2",
        "storage_key": "property/6767906449166817/019f858d-cdcf-77c4-8034-2baea37506c2.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Step into comfort in this inviting bedroom, featuring a plush queen-size bed, convenient nightstands, and ample storage with a stylish dresser. Natural light streams through the window, creating a serene atmosphere.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, nightstands, dresser, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dbb7faaa-99e4-4f77-83f8-5b1ef9e7ba42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019f858d-cd6c-70dd-9b27-f261403f847e.webp",
      "image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and fireplace.",
        "public_id": "019f858d-cd6c-70dd-9b27-f261403f847e",
        "storage_key": "property/6767906449166817/019f858d-cd6c-70dd-9b27-f261403f847e.webp",
        "width": 1531,
        "height": 1027
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable leather sofa, armchair, and a charming fireplace, perfect for relaxing evenings.",
      "link": "",
      "alt_text": "Living room with a leather sofa, armchair, coffee table, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1dc7621e-c0cc-4a4d-9d7c-5237e53f2763",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019f858d-cdda-7060-a3e4-0f39d72b6f0d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, white countertops, black appliances, and a breakfast bar.",
        "public_id": "019f858d-cdda-7060-a3e4-0f39d72b6f0d",
        "storage_key": "property/6767906449166817/019f858d-cdda-7060-a3e4-0f39d72b6f0d.webp",
        "width": 1531,
        "height": 1027
      },
      "title": "Apartment",
      "description": "Discover this sleek kitchen featuring ample cabinet space, modern appliances, and a stylish breakfast bar, perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, white countertops, black appliances, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb088407-58fb-474b-adb4-de992648694f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019f858d-cd6b-7050-b269-f9a054d837e1.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs adjacent to a kitchen.",
        "public_id": "019f858d-cd6b-7050-b269-f9a054d837e1",
        "storage_key": "property/6767906449166817/019f858d-cd6b-7050-b269-f9a054d837e1.webp",
        "width": 1530,
        "height": 1028
      },
      "title": "Apartment",
      "description": "Enjoy meals in your spacious dining area, perfectly situated next to the open-concept kitchen, creating a seamless flow for entertaining and everyday living.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs adjacent to a kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_08834092-1f28-4eeb-9795-d2322f58c19f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019e84d8-877a-77d8-bdd9-aaa55d325684.webp",
      "image_media": {
        "alt_text": "Curving swimming pool with lounge chairs and palm trees.",
        "public_id": "019e84d8-877a-77d8-bdd9-aaa55d325684",
        "storage_key": "property/6767906449166817/019e84d8-877a-77d8-bdd9-aaa55d325684.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable seating. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Curving swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_503a2d72-d5c1-4a57-ab00-b2c9f4d888ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019e84d8-8b99-77da-a6e9-5a3b87d271eb.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e84d8-8b99-77da-a6e9-5a3b87d271eb",
        "storage_key": "property/6767906449166817/019e84d8-8b99-77da-a6e9-5a3b87d271eb.webp",
        "width": 1104,
        "height": 760
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51217853-4d97-407f-8b2d-f5c35a4ec7cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019e84d8-7fcc-730a-bd99-06883595a36c.webp",
      "image_media": {
        "alt_text": "Bright green Adirondack chairs face a sparkling blue swimming pool, with apartment buildings and trees in the background under a cloudy sky.",
        "public_id": "019e84d8-7fcc-730a-bd99-06883595a36c",
        "storage_key": "property/6767906449166817/019e84d8-7fcc-730a-bd99-06883595a36c.webp",
        "width": 1151,
        "height": 823
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor swimming pool, complete with comfortable seating and a serene atmosphere. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "",
      "alt_text": "Bright green Adirondack chairs face a sparkling blue swimming pool, with apartment buildings and trees in the background under a cloudy sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9099f893-4813-487d-bc1c-654506d98ff1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019f858d-e293-7642-9654-69c6097fea90.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets and stainless steel appliances.",
        "public_id": "019f858d-e293-7642-9654-69c6097fea90",
        "storage_key": "property/6767906449166817/019f858d-e293-7642-9654-69c6097fea90.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Spacious and functional kitchen featuring sleek gray cabinetry, modern appliances, and a stone tile backsplash.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8081e7bb-3d8b-4ca5-8f33-aa3a9c310e0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019f858d-dfdd-768e-8236-f5f99e9ea6af.webp",
      "image_media": {
        "alt_text": "Modern living room with gray sectional sofa, coffee table, accent chair, and console table.",
        "public_id": "019f858d-dfdd-768e-8236-f5f99e9ea6af",
        "storage_key": "property/6767906449166817/019f858d-dfdd-768e-8236-f5f99e9ea6af.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Step into this stylish living room, featuring a comfortable gray sectional, a chic accent chair, and a modern console table. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Modern living room with gray sectional sofa, coffee table, accent chair, and console table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_85d57c09-5374-40f6-8d54-6db584ba7c98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019f858d-cd57-750a-93d9-a4199f6a6ddd.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and closet. Bathroom visible through doorway.",
        "public_id": "019f858d-cd57-750a-93d9-a4199f6a6ddd",
        "storage_key": "property/6767906449166817/019f858d-cd57-750a-93d9-a4199f6a6ddd.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom, featuring a plush king-size bed, elegant nightstands, and ample closet space. The adjoining bathroom offers modern fixtures.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and closet. Bathroom visible through doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_495db797-b13c-48cd-b3d7-b45f3eb88f63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019f858d-cd53-74d9-b3c1-003c5d432587.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, patterned rug, and sliding glass doors.",
        "public_id": "019f858d-cd53-74d9-b3c1-003c5d432587",
        "storage_key": "property/6767906449166817/019f858d-cd53-74d9-b3c1-003c5d432587.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed living room, featuring a spacious sectional sofa, a stylish patterned rug, and abundant natural light.",
      "link": "",
      "alt_text": "Modern living room with a sectional sofa, patterned rug, and sliding glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78d6f6dd-ee19-4af9-ae5b-a10436c049ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019e84d8-8c50-76e0-8173-ed3a4d002de4.webp",
      "image_media": {
        "alt_text": "leasing office with desks, chairs, and computers",
        "public_id": "019e84d8-8c50-76e0-8173-ed3a4d002de4",
        "storage_key": "property/6767906449166817/019e84d8-8c50-76e0-8173-ed3a4d002de4.webp",
        "width": 1000,
        "height": 669
      },
      "title": "Community",
      "description": "Welcome to our leasing office, designed for your comfort and convenience. Meet with our team and discover your new home.",
      "link": "",
      "alt_text": "leasing office with desks, chairs, and computers",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1db00567-c7e0-44eb-9027-52d8899fce1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019e84d8-8b34-7349-9726-2c4960bfc114.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
        "public_id": "019e84d8-8b34-7349-9726-2c4960bfc114",
        "storage_key": "property/6767906449166817/019e84d8-8b34-7349-9726-2c4960bfc114.webp",
        "width": 798,
        "height": 529
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush greenery and comfortable lounge seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_765a2571-f329-46af-80fc-2386d810247e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Taste of Texas",
      "poi_type": "Restaurants",
      "poi_address": "10505 Katy Fwy, Houston, TX 77024, USA",
      "poi_short_description": "Relaxed restaurant featuring grilled steaks and seafood, plus a salad bar.",
      "poi_long_description": "People say this steakhouse offers delicious steaks, including ribeye, porterhouse, and tomahawk, as well as a salad bar with a wide variety of fresh options and homemade breads. They highlight the unique Texas history decor, the fun experience of selecting your own steak, and the attentive service. They also like the generous portions and the option to celebrate special occasions with a complimentary dessert and photo.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-36d0-71fa-bc04-6e9ef342de11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-36d0-71fa-bc04-6e9ef342de11",
        "storage_key": "property/6767906449166817/019d089b-36d0-71fa-bc04-6e9ef342de11.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.tasteoftexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4832776214782661752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "taste-of-texas",
      "poi_latitude": "29.7828164",
      "poi_longitude": "-95.5569012",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 713-932-6901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7f04-73a6-858f-5899b25bc161.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-7f04-73a6-858f-5899b25bc161",
        "storage_key": "property/6767906449166817/019d089b-7f04-73a6-858f-5899b25bc161.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz0peBLTEQIYReNQTuVx4EUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_2f4f381f-2467-43d0-896f-c872b058b289",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Topgolf Houston - Katy",
      "poi_type": "Restaurants",
      "poi_address": "1030 Memorial Brook Blvd, Houston, TX 77084, USA",
      "poi_short_description": "Sports-bar chain, with driving lanes, live entertainment and an outdoor pool table for guests to practice golf swings.",
      "poi_long_description": "People say this restaurant offers a wide selection of drinks, including cocktails and mango lemonade, and the steak nachos and Asian boneless wings are delicious. They also highlight the fun, vibey, and kid-friendly atmosphere, and the friendly, attentive staff.\n\nOther reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-3674-77ca-b680-a8c605d3d750.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-3674-77ca-b680-a8c605d3d750",
        "storage_key": "property/6767906449166817/019d089b-3674-77ca-b680-a8c605d3d750.webp",
        "width": 750,
        "height": 500
      },
      "poi_business_url": "https://topgolf.com/us/houston-west/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11763942538676567838&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-houston---katy",
      "poi_latitude": "29.7867434",
      "poi_longitude": "-95.6500505",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-406-3176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7f04-73a6-858f-5899b25bc161.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-7f04-73a6-858f-5899b25bc161",
        "storage_key": "property/6767906449166817/019d089b-7f04-73a6-858f-5899b25bc161.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhW-E02bZQIYRHn_sL2nrQaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_740e873e-a0f7-4052-9a36-7cc0915f67f0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "UMI SUSHI & SEAFOOD BUFFET",
      "poi_type": "Restaurants",
      "poi_address": "11681 Westheimer Rd, Houston, TX 77077, USA",
      "poi_short_description": "Lobster and shrimp are among the many seafood dishes offered here alongside a variety of sushi rolls and desserts.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of fresh seafood, including lobster, crab, and sashimi, as well as hot pot and other dishes. They also highlight the excellent service, friendly staff, and the value for the price, especially with promotions.\n\nSome reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-3687-7129-b7f6-465ec054db6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-3687-7129-b7f6-465ec054db6e",
        "storage_key": "property/6767906449166817/019d089b-3687-7129-b7f6-465ec054db6e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.umibuffet.com/locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=9008796752262214487&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "umi-sushi--seafood-buffet",
      "poi_latitude": "29.7359986",
      "poi_longitude": "-95.5823155",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-957-6888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7f04-73a6-858f-5899b25bc161.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-7f04-73a6-858f-5899b25bc161",
        "storage_key": "property/6767906449166817/019d089b-7f04-73a6-858f-5899b25bc161.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg6UbWS7dQIYRVzNIYOqsBX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_98c69c8a-665b-40d9-9e4d-34394e1f159c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "La Pasha Lounge & Grill",
      "poi_type": "Restaurants",
      "poi_address": "2475 S Kirkwood Rd, Houston, TX 77077, USA",
      "poi_short_description": "Upscale Mediterranean restaurant with a casual grill menu and relaxed vibes.",
      "poi_long_description": "People say this Mediterranean restaurant offers delicious lamb chops, shawarma fries, and mixed grill, as well as refreshing mint lemonade and a variety of hookah flavors. They highlight the generous portions, reasonable prices, and the fun, chill atmosphere, perfect for hanging out with friends. They also like the attentive, friendly, and professional staff, and the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-363c-749e-95af-3e54998150a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-363c-749e-95af-3e54998150a4",
        "storage_key": "property/6767906449166817/019d089b-363c-749e-95af-3e54998150a4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lapashalounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3307250644010695834&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-pasha-lounge--grill",
      "poi_latitude": "29.7382117",
      "poi_longitude": "-95.5880939",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 832-979-4961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7f04-73a6-858f-5899b25bc161.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-7f04-73a6-858f-5899b25bc161",
        "storage_key": "property/6767906449166817/019d089b-7f04-73a6-858f-5899b25bc161.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbz5lkwzdQIYRmnxwK_C25S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_a2bf2d18-a400-4c73-b17b-d4094379660d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Kim Sơn",
      "poi_type": "Restaurants",
      "poi_address": "10603 Bellaire Blvd, Houston, TX 77072, USA",
      "poi_short_description": "Casual place featuring a Vietnamese comfort food buffet, plus a sushi bar and a noodle bar.",
      "poi_long_description": "Diners say this Vietnamese restaurant offers a buffet with a wide variety of dishes, including pho, banh xeo, bun bo Hue, dim sum, and Chinese infusion dishes, as well as a noodle bar, street food section, and dessert bar. They also highlight the attentive service, spacious seating, and fresh seafood.\n\nSome reviews mention the buffet can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-3c84-7581-87be-fc986a3c6fb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-3c84-7581-87be-fc986a3c6fb8",
        "storage_key": "property/6767906449166817/019d089b-3c84-7581-87be-fc986a3c6fb8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://rebrand.ly/kim-son",
      "poi_directions_map_url": "https://maps.google.com/?cid=3076691630305131255&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kim-sn",
      "poi_latitude": "29.7030634",
      "poi_longitude": "-95.568247",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-598-1777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7f04-73a6-858f-5899b25bc161.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-7f04-73a6-858f-5899b25bc161",
        "storage_key": "property/6767906449166817/019d089b-7f04-73a6-858f-5899b25bc161.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8cdReDHdQIYR9zrBm7yasio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_d4547f7e-0c53-42e2-8ef2-6d2cd3523231",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Memorial City Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "303 Memorial City Way, Houston, TX 77024, USA",
      "poi_short_description": "Bustling shopping mall in the Memorial City area featuring premium and value outlets, as well as a Target grocery store.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including high-end brands, affordable everyday shops, and a Target, as well as a food court with many options, sit-down restaurants, and an ice skating rink. They highlight the spacious, clean, and safe environment, and the convenient parking and easy access from the highway. They also like the family-friendly attractions, such as the carousel, train, and play areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-3c3d-7644-96ab-a94c24bf0c92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-3c3d-7644-96ab-a94c24bf0c92",
        "storage_key": "property/6767906449166817/019d089b-3c3d-7644-96ab-a94c24bf0c92.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.memorialcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11072518101315744963&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-city-mall",
      "poi_latitude": "29.7807002",
      "poi_longitude": "-95.5379007",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 713-464-8640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7f15-75e3-8264-c8cee20f23ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-7f15-75e3-8264-c8cee20f23ac",
        "storage_key": "property/6767906449166817/019d089b-7f15-75e3-8264-c8cee20f23ac.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIXBsJZbEQIYRw_QBZox8qZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_77ad61b3-6099-4abb-892c-111a3e4c94a0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "PlazAmericas",
      "poi_type": "Shopping & Retail",
      "poi_address": "201 Sharpstown Center, Houston, TX 77036, USA",
      "poi_short_description": "Modern mall featuring a cinema and a food court, along with a host of stores.",
      "poi_long_description": "Large shopping plaza features apparel, footwear, jewelry & specialty shops, plus a kids' play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-3cd9-77a2-a1c7-103b172d164d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-3cd9-77a2-a1c7-103b172d164d",
        "storage_key": "property/6767906449166817/019d089b-3cd9-77a2-a1c7-103b172d164d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.plazamericas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14493713742070442760&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "plazamericas",
      "poi_latitude": "29.7066789",
      "poi_longitude": "-95.5155405",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 713-777-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7f15-75e3-8264-c8cee20f23ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-7f15-75e3-8264-c8cee20f23ac",
        "storage_key": "property/6767906449166817/019d089b-7f15-75e3-8264-c8cee20f23ac.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJC02fjlnCQIYRCGtOgNsDJMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_14277487-08d0-40e3-b544-a5106e68eec4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "9710 Katy Fwy, Houston, TX 77055, USA",
      "poi_short_description": "Clean store stocking fresh items from cheese to tortillas, alongside beer and wine.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meat, and HEB brand products, including sushi and prepared meals. They highlight the store is clean, well-stocked, and has a large selection of flowers. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-3cf9-7008-a8de-6e03cf47b6b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-3cf9-7008-a8de-6e03cf47b6b2",
        "storage_key": "property/6767906449166817/019d089b-3cf9-7008-a8de-6e03cf47b6b2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/houston/bunker-hill-h-e-b-109?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=2667082563992905186&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.787678",
      "poi_longitude": "-95.53242",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 713-647-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7efb-76de-ab3c-960c53ff8316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-7efb-76de-ab3c-960c53ff8316",
        "storage_key": "property/6767906449166817/019d089b-7efb-76de-ab3c-960c53ff8316.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtytnNpLEQIYR4mVvDXZhAyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4a2d4433-93e0-42dc-82f2-eceeb2744680",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "CITYCENTRE",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 Town and Country Blvd, Houston, TX 77024, USA",
      "poi_short_description": "Sophisticated, European-style outdoor mall featuring eateries, a movie theater and a hotel.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops, restaurants, and entertainment options, including a movie theater and a fitness center. They highlight the fun, family-friendly atmosphere, and the safe, clean, and well-maintained environment. They also like the convenient location and ample parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-45cd-735d-9f58-67c678cbcb4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-45cd-735d-9f58-67c678cbcb4d",
        "storage_key": "property/6767906449166817/019d089b-45cd-735d-9f58-67c678cbcb4d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.citycentrehouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16787131420789938490&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "citycentre",
      "poi_latitude": "29.7810228",
      "poi_longitude": "-95.5592668",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 713-463-4692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7f15-75e3-8264-c8cee20f23ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-7f15-75e3-8264-c8cee20f23ac",
        "storage_key": "property/6767906449166817/019d089b-7f15-75e3-8264-c8cee20f23ac.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTQ_xOrPEQIYROpn7zRXf9-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_0f937ea4-cd5f-4928-a792-bb7da05f690b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "H Mart Houston Blalock",
      "poi_type": "Shopping & Retail",
      "poi_address": "1302 Blalock Rd, Houston, TX 77055, USA",
      "poi_short_description": "Asian-inspired market chain carrying produce and other groceries, along with restaurants and bakeries inside.",
      "poi_long_description": "Shoppers say this Asian grocery store offers a wide variety of Korean food, including fresh produce, seafood, and baked goods from the in-house bakery. They also highlight the delicious food court with its diverse selection of Asian cuisine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-4775-733c-888e-1ea0f1930570.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-4775-733c-888e-1ea0f1930570",
        "storage_key": "property/6767906449166817/019d089b-4775-733c-888e-1ea0f1930570.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.hmart.com/storelocator/index/index/id/43/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2382257153472015568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart-houston-blalock",
      "poi_latitude": "29.7925583",
      "poi_longitude": "-95.5208535",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 713-468-0606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7efb-76de-ab3c-960c53ff8316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-7efb-76de-ab3c-960c53ff8316",
        "storage_key": "property/6767906449166817/019d089b-7efb-76de-ab3c-960c53ff8316.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7mYn_XEQIYR0CxVZEJ6DyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_5418f1d1-fb26-4beb-8f70-ed0e0223e4c8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Houston Christian University",
      "poi_type": "Education",
      "poi_address": "7502 Fondren Rd, Houston, TX 77074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-44da-73be-ad36-d711cff5577d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-44da-73be-ad36-d711cff5577d",
        "storage_key": "property/6767906449166817/019d089b-44da-73be-ad36-d711cff5577d.webp",
        "width": 1197,
        "height": 524
      },
      "poi_business_url": "https://hc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13811529488055007762&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "houston-christian-university",
      "poi_latitude": "29.6946466",
      "poi_longitude": "-95.5162157",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7f00-73ef-b9ab-559da9467f10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-7f00-73ef-b9ab-559da9467f10",
        "storage_key": "property/6767906449166817/019d089b-7f00-73ef-b9ab-559da9467f10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo1jPUWfCQIYREvpZjORorL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f0411cea-c8f3-4524-8841-434c2a60c715",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Houston City College - Alief Hayes Campus",
      "poi_type": "Education",
      "poi_address": "2811 Hayes Rd, Houston, TX 77082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-45b2-71eb-aca4-00a66ea7a6e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-45b2-71eb-aca4-00a66ea7a6e1",
        "storage_key": "property/6767906449166817/019d089b-45b2-71eb-aca4-00a66ea7a6e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hccs.edu/locations/northwest-college/alief-hayes-campus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7626777246185878854&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "houston-city-college---alief-hayes-campus",
      "poi_latitude": "29.7336019",
      "poi_longitude": "-95.5748367",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 713-718-2339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7f00-73ef-b9ab-559da9467f10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-7f00-73ef-b9ab-559da9467f10",
        "storage_key": "property/6767906449166817/019d089b-7f00-73ef-b9ab-559da9467f10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD2aIxsXcQIYRRvXwO3_B12k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_76366e0f-f03c-4de6-b257-858bcf226cd2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Houston Community College - Spring Branch Campus",
      "poi_type": "Education",
      "poi_address": "1010 W Sam Houston Pkwy N, Houston, TX 77043, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-4cad-7752-a3fe-5028e1a694b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-4cad-7752-a3fe-5028e1a694b4",
        "storage_key": "property/6767906449166817/019d089b-4cad-7752-a3fe-5028e1a694b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hccs.edu/locations/northwest-college/spring-branch-campus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=185094565414141868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "houston-community-college---spring-branch-campus",
      "poi_latitude": "29.7862554",
      "poi_longitude": "-95.5611093",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 713-718-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7f00-73ef-b9ab-559da9467f10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-7f00-73ef-b9ab-559da9467f10",
        "storage_key": "property/6767906449166817/019d089b-7f00-73ef-b9ab-559da9467f10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6a3LOLXEQIYRrH9dzYaWkQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a8c6486e-ae5a-4dab-a8f8-9a0657223882",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Seismique",
      "poi_type": "Entertainment",
      "poi_address": "2306 S Texas 6, Houston, TX 77077, USA",
      "poi_short_description": "Whimsical, sci-fi-themed museum filled with interactive exhibits and artworks, plus a snack bar and a souvenir shop.",
      "poi_long_description": "People say this art museum offers interactive art, immersive exhibits, and a fun experience for adults and kids. They also highlight the friendly staff, the unique and imaginative artwork, and the cool visuals.\n\nOther reviews mention the price can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-4c94-74ce-8da0-eca8997a94da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-4c94-74ce-8da0-eca8997a94da",
        "storage_key": "property/6767906449166817/019d089b-4c94-74ce-8da0-eca8997a94da.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.seismique.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15664401956141516437&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seismique",
      "poi_latitude": "29.739995",
      "poi_longitude": "-95.6460929",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 346-202-6006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83ca-7549-a5c3-11611ec5e9ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83ca-7549-a5c3-11611ec5e9ac",
        "storage_key": "property/6767906449166817/019d089b-83ca-7549-a5c3-11611ec5e9ac.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJr95ma6rdQIYRlca_5pUiY9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4a4e8bb8-c868-47af-ba32-7436f3ec2202",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Two Briarlake Plaza",
      "poi_type": "Entertainment",
      "poi_address": "2050 W Sam Houston Pkwy S, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-4dd9-70db-b9c3-9cb4a8e7bb6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-4dd9-70db-b9c3-9cb4a8e7bb6c",
        "storage_key": "property/6767906449166817/019d089b-4dd9-70db-b9c3-9cb4a8e7bb6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.briarlakeplaza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1606304928683096208&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "two-briarlake-plaza",
      "poi_latitude": "29.7454426",
      "poi_longitude": "-95.5590542",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 713-952-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83fa-7479-9271-3e804dd5af25",
        "storage_key": "property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxUoIQ0rDQIYRkHgdc9K9ShY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_f7dc088f-cdaf-46a4-b71e-5a130e365fc9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "LeRoy Crump Stadium",
      "poi_type": "Entertainment",
      "poi_address": "12321 High Star Dr, Houston, TX 77072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-4f25-74da-b801-8ece18e197df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-4f25-74da-b801-8ece18e197df",
        "storage_key": "property/6767906449166817/019d089b-4f25-74da-b801-8ece18e197df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11097112274259925753&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "leroy-crump-stadium",
      "poi_latitude": "29.7126467",
      "poi_longitude": "-95.59804",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-498-8110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83f5-7503-9716-db3059b7246f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83f5-7503-9716-db3059b7246f",
        "storage_key": "property/6767906449166817/019d089b-83f5-7503-9716-db3059b7246f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa251iQPdQIYR-drjg9HcAJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_853d8e6b-deb7-4d7f-8f36-9dc9b13900df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Darrell Tully Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1050 Dairy Ashford St, Houston, TX 77079, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-53c5-754e-841a-5ee1afb38888.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-53c5-754e-841a-5ee1afb38888",
        "storage_key": "property/6767906449166817/019d089b-53c5-754e-841a-5ee1afb38888.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cms.springbranchisd.com/athletics/For-Parents-Students/Facilities-Maps/Darrell-Tully-Stadium",
      "poi_directions_map_url": "https://maps.google.com/?cid=1578143533437279935&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "darrell-tully-stadium",
      "poi_latitude": "29.7782743",
      "poi_longitude": "-95.6043633",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 713-251-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83f5-7503-9716-db3059b7246f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83f5-7503-9716-db3059b7246f",
        "storage_key": "property/6767906449166817/019d089b-83f5-7503-9716-db3059b7246f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW8vCj53bQIYRv94bqy6x5hU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_5e4e9b15-a5f8-4276-87e1-943c7f448262",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Don Coleman Coliseum",
      "poi_type": "Entertainment",
      "poi_address": "1050 Dairy Ashford Rd, Houston, TX 77079, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-5399-72ac-94dd-f85afad92ca3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-5399-72ac-94dd-f85afad92ca3",
        "storage_key": "property/6767906449166817/019d089b-5399-72ac-94dd-f85afad92ca3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.springbranchisd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7501910146797277884&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "don-coleman-coliseum",
      "poi_latitude": "29.77653819999999",
      "poi_longitude": "-95.6043854",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-560-7651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83fa-7479-9271-3e804dd5af25",
        "storage_key": "property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNT4uqH_cQIYRvBLAHIgjHGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_6df4a35e-9ac3-4d7a-a352-74955c339b3b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "815 Town and Country Blvd, Houston, TX 77024, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-5403-7148-bd14-ed164b007d48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-5403-7148-bd14-ed164b007d48",
        "storage_key": "property/6767906449166817/019d089b-5403-7148-bd14-ed164b007d48.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lifetime.life/locations/tx/city-centre-houston.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=17896619950549572541&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "29.7808751",
      "poi_longitude": "-95.5601764",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 713-464-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83fa-7479-9271-3e804dd5af25",
        "storage_key": "property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvXnzS7LEQIYRvRutUAaRXfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e61bc850-7f48-49d7-9769-82f4d70ed0a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12553 Westheimer Rd, Houston, TX 77077, USA",
      "poi_short_description": "Spacious fitness facility featuring cardio machines, free weights and spin classes, plus a pool and sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-59db-74fc-b324-74608f4ad900.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-59db-74fc-b324-74608f4ad900",
        "storage_key": "property/6767906449166817/019d089b-59db-74fc-b324-74608f4ad900.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/houston-tx/dairy-ashford-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=10653352508494424995&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "29.7341821",
      "poi_longitude": "-95.6045559",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-493-1874",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83fa-7479-9271-3e804dd5af25",
        "storage_key": "property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi3YkbF_cQIYRo6vTn6lP2JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_900e6b53-5448-4d5d-818e-b410e06f1134",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "12850 Memorial Dr Suite 1300, Houston, TX 77024, USA",
      "poi_short_description": "Retailer for cosmetics, fragrance, skincare, and hair care products, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-59b2-73f3-89f6-bf71a1955ba3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-59b2-73f3-89f6-bf71a1955ba3",
        "storage_key": "property/6767906449166817/019d089b-59b2-73f3-89f6-bf71a1955ba3.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/houston-tx-403",
      "poi_directions_map_url": "https://maps.google.com/?cid=12129290203997500304&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "29.7738025",
      "poi_longitude": "-95.5603081",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-331-0065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83fa-7479-9271-3e804dd5af25",
        "storage_key": "property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn_RK26zEQIYRkHPlQi3lU6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_1f7b172e-2212-4e28-88bf-7215daf25c9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9603 Westheimer Rd, Houston, TX 77063, USA",
      "poi_short_description": "Clean fitness center with a pool, basketball courts and a sauna, plus strength classes.",
      "poi_long_description": "People say this gym offers a wide variety of workout equipment, including treadmills, free weights, and cardio machines, and is conveniently located.\n\nOther reviews mention the facilities can be poorly maintained and the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-5b18-77cb-9966-4d5ba1675edf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-5b18-77cb-9966-4d5ba1675edf",
        "storage_key": "property/6767906449166817/019d089b-5b18-77cb-9966-4d5ba1675edf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=674&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1923095509877188466&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "29.7362567",
      "poi_longitude": "-95.5363836",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-470-4098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83fa-7479-9271-3e804dd5af25",
        "storage_key": "property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVS8gxbDQIYRcudgXy01sBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bbc4329c-07f5-4803-84ec-08e08a79bb00",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10770 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Clean gym offering cardio- and strength-training machines plus massage beds, and run by helpful staff.",
      "poi_long_description": "Some gym goers say this fitness center offers a wide variety of equipment, a peaceful environment, and a great opportunity to achieve fitness goals.\n\nOther reviews mention the customer service can be disappointing and management can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-55e6-7252-ab43-259faff699a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-55e6-7252-ab43-259faff699a1",
        "storage_key": "property/6767906449166817/019d089b-55e6-7252-ab43-259faff699a1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12212685552691916244&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "29.7377373",
      "poi_longitude": "-95.5660911",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 713-359-0012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83fa-7479-9271-3e804dd5af25",
        "storage_key": "property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWMIfELdQIYR1C2_-c0sfKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_de4204c8-4116-4950-b5d7-1dfbd1c72856",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Fitness Connection",
      "poi_type": "Health and Wellness",
      "poi_address": "7355 Hwy 6, Houston, TX 77083, USA",
      "poi_short_description": "Casual gym featuring a basketball court and a sauna, plus clean equipment.",
      "poi_long_description": "Gym goers say this gym offers a wide variety of equipment, including a women’s only workout area, and is kept very clean. They also highlight the friendly and helpful staff, who create a welcoming and positive atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-5d25-7604-8e55-fb32aa57ebe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-5d25-7604-8e55-fb32aa57ebe2",
        "storage_key": "property/6767906449166817/019d089b-5d25-7604-8e55-fb32aa57ebe2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://fitnessconnection.com/gyms/mission-bend/",
      "poi_directions_map_url": "https://maps.google.com/?cid=798210941787223293&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-connection",
      "poi_latitude": "29.6963207",
      "poi_longitude": "-95.6421865",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 832-290-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83fa-7479-9271-3e804dd5af25",
        "storage_key": "property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjQIWKcrdQIYR_bQOWZ_QEws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1feb5cf9-d908-4733-86bd-c691c6374123",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Memorial Hermann Southwest Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "7600 Beechnut St, Houston, TX 77074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-64f6-703d-b3de-ba95f7c9c5c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-64f6-703d-b3de-ba95f7c9c5c1",
        "storage_key": "property/6767906449166817/019d089b-64f6-703d-b3de-ba95f7c9c5c1.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://memorialhermann.org/locations/southwest?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=4615674855845486349&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-hermann-southwest-hospital",
      "poi_latitude": "29.692891",
      "poi_longitude": "-95.5212694",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-456-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-8536-71ab-8b23-0b758aa2a639.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-8536-71ab-8b23-0b758aa2a639",
        "storage_key": "property/6767906449166817/019d089b-8536-71ab-8b23-0b758aa2a639.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aSzG4zCQIYRDV9fldMrDkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c8eff176-e4a9-465f-96f2-178e00ec9139",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "HCA Houston Healthcare West",
      "poi_type": "Health and Wellness",
      "poi_address": "12141 Richmond Ave., Houston, TX 77082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-6552-7188-afda-aebf41f05300.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-6552-7188-afda-aebf41f05300",
        "storage_key": "property/6767906449166817/019d089b-6552-7188-afda-aebf41f05300.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/west?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=266204689841745394&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hca-houston-healthcare-west",
      "poi_latitude": "29.7288209",
      "poi_longitude": "-95.5942013",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-558-3444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-8536-71ab-8b23-0b758aa2a639.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-8536-71ab-8b23-0b758aa2a639",
        "storage_key": "property/6767906449166817/019d089b-8536-71ab-8b23-0b758aa2a639.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5byGn_rcQIYR8m2PR8G_sQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0cd3c587-66fe-43ef-a862-129e6d3830c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Camden Park Westchase",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2951 Wilcrest Dr, Houston, TX 77042, USA",
      "poi_short_description": "Popular park featuring a splash pad, dog parks and a playground for kids.",
      "poi_long_description": "Visitors say this park offers a fantastic interactive playground with water features, a giant hummingbird sculpture, and a separate dog park with areas for small and large dogs. They also highlight the plentiful green space, shaded seating, live music, and welcoming atmosphere, making it a great place for families with young children.\n\nSome reviews mention parking can be limited, especially on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-6714-73ec-a406-c5c3ac177d5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-6714-73ec-a406-c5c3ac177d5b",
        "storage_key": "property/6767906449166817/019d089b-6714-73ec-a406-c5c3ac177d5b.webp",
        "width": 1280,
        "height": 714
      },
      "poi_business_url": "https://camdenparkwestchase.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7949308463253431202&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "camden-park-westchase",
      "poi_latitude": "29.729676",
      "poi_longitude": "-95.5707528",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 713-780-9434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-887d-71a9-9d0f-6a3658d489b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-887d-71a9-9d0f-6a3658d489b4",
        "storage_key": "property/6767906449166817/019d089b-887d-71a9-9d0f-6a3658d489b4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMVhvDqDdQIYRoiM6Gu6dUW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a9f709f0-9a95-4c29-81ec-2fa4651981db",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Arthur Storey Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7400 W Sam Houston Pkwy S, Houston, TX 77036, USA",
      "poi_short_description": "Green space centered around a pond, with a jogging trail along a narrow bayou & a tai chi court.",
      "poi_long_description": "People say this park offers a scenic lake, walking trails, a playground, and plenty of parking. They highlight the peaceful and quiet atmosphere, and the beautiful sunsets. They also like the opportunities for cycling, jogging, and photography.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-6b7c-76e8-81c5-3e1e0046ab3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-6b7c-76e8-81c5-3e1e0046ab3f",
        "storage_key": "property/6767906449166817/019d089b-6b7c-76e8-81c5-3e1e0046ab3f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://hcp4.net/parks/arthur-storey-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15899668444003781872&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arthur-storey-park",
      "poi_latitude": "29.7002473",
      "poi_longitude": "-95.5606594",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-887d-71a9-9d0f-6a3658d489b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-887d-71a9-9d0f-6a3658d489b4",
        "storage_key": "property/6767906449166817/019d089b-887d-71a9-9d0f-6a3658d489b4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSi-DMrCQIYR8ExVszX4ptw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2c6d1383-95d9-46f8-97df-8dec2b3ad027",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Bayland Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6400 Bissonnet St, Houston, TX 77074, USA",
      "poi_short_description": "Landscaped multi-use facility with baseball, football and soccer fields, plus a running track and playground.",
      "poi_long_description": "Open space with walking trails, baseball, soccer & football fields, a pavilion, a playground & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-6d00-709e-af8b-4c4fd02d0920.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-6d00-709e-af8b-4c4fd02d0920",
        "storage_key": "property/6767906449166817/019d089b-6d00-709e-af8b-4c4fd02d0920.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=3445883988060373707&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bayland-park",
      "poi_latitude": "29.6952295",
      "poi_longitude": "-95.4962776",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-887d-71a9-9d0f-6a3658d489b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-887d-71a9-9d0f-6a3658d489b4",
        "storage_key": "property/6767906449166817/019d089b-887d-71a9-9d0f-6a3658d489b4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb48Y7RTCQIYRy4KL5To90i8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_738f32a1-a195-478e-9893-979def9a2ef2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Alief Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11903 Bellaire Blvd, Houston, TX 77072, USA",
      "poi_short_description": "Large recreational facility featuring a pool, playground and skate park, along with sports fields and a library in a clean setting amid lush greenery.",
      "poi_long_description": "People say this park offers a wide variety of amenities, including a playground, sports facilities, a pool, a library, and community services. They highlight the clean, well-maintained facilities, the abundance of activities for all ages, and the welcoming atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-6d29-72ec-9530-5324f2e73ac7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-6d29-72ec-9530-5324f2e73ac7",
        "storage_key": "property/6767906449166817/019d089b-6d29-72ec-9530-5324f2e73ac7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.houstontx.gov/parks/aliefneighborhoodcenter.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14822750300214923800&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alief-community-park",
      "poi_latitude": "29.7019476",
      "poi_longitude": "-95.589824",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 832-395-7075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-887d-71a9-9d0f-6a3658d489b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-887d-71a9-9d0f-6a3658d489b4",
        "storage_key": "property/6767906449166817/019d089b-887d-71a9-9d0f-6a3658d489b4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvVvePRHdQIYRGBKgHt38tM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6de71128-f716-4447-9153-a56d31596acb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Terry Hershey Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15200 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Multi-use park featuring picnic tables, playgrounds, paved paths, biking trails and dirt tracks.",
      "poi_long_description": "Visitors say this park offers a great place to walk, run, or bike, with paved paths that are good for cyclists. They also highlight the park's natural beauty, with plenty of trees and a sense of escape from the city.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-6ebf-706d-82a1-bde3ee0f2963.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-6ebf-706d-82a1-bde3ee0f2963",
        "storage_key": "property/6767906449166817/019d089b-6ebf-706d-82a1-bde3ee0f2963.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=839903759849692222&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "terry-hershey-park",
      "poi_latitude": "29.7817875",
      "poi_longitude": "-95.623719",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-887d-71a9-9d0f-6a3658d489b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-887d-71a9-9d0f-6a3658d489b4",
        "storage_key": "property/6767906449166817/019d089b-887d-71a9-9d0f-6a3658d489b4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnSEHspTbQIYRPhxbAwXwpws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c10c2109-c85b-4f1e-a55b-56766b0d1bf2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Shell Woodcreek Complex",
      "poi_type": "Major Employers & Offices",
      "poi_address": "150 N Dairy Ashford Rd, Houston, TX 77079, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-726e-70ac-baa8-b748c41d1174.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-726e-70ac-baa8-b748c41d1174",
        "storage_key": "property/6767906449166817/019d089b-726e-70ac-baa8-b748c41d1174.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shell.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6245627658790227837&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shell-woodcreek-complex",
      "poi_latitude": "29.7876018",
      "poi_longitude": "-95.6045079",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 832-337-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83fa-7479-9271-3e804dd5af25",
        "storage_key": "property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7d-a7qHbQIYRfc-L0UPtrFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1fa14775-7c21-400f-b1aa-83e7d7e305bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Phillips 66",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2331 CityWest Blvd, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7539-763e-ab18-8d11e4cdc1e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-7539-763e-ab18-8d11e4cdc1e7",
        "storage_key": "property/6767906449166817/019d089b-7539-763e-ab18-8d11e4cdc1e7.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.phillips66.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15860930961646065326&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phillips-66",
      "poi_latitude": "29.7405404",
      "poi_longitude": "-95.5609181",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83fa-7479-9271-3e804dd5af25",
        "storage_key": "property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZb3nsDrDQIYRrpbov6xYHdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_41ca7902-acca-45d7-8bf9-c71230866a08",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "ConocoPhillips SPIRIT TWO",
      "poi_type": "Major Employers & Offices",
      "poi_address": "935 N Eldridge Pkwy, Houston, TX 77079, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-753f-73af-9b7c-c70b4c529099.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-753f-73af-9b7c-c70b4c529099",
        "storage_key": "property/6767906449166817/019d089b-753f-73af-9b7c-c70b4c529099.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.conocophillips.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3780074536983081433&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "conocophillips-spirit-two",
      "poi_latitude": "29.7832772",
      "poi_longitude": "-95.6192391",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-293-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83fa-7479-9271-3e804dd5af25",
        "storage_key": "property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxF6apbbQIYR2TFggcOFdTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2a4b3e54-dbef-4240-874c-67d211365701",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "ConocoPhillips World Headquarters - SPIRIT ONE",
      "poi_type": "Major Employers & Offices",
      "poi_address": "925 N Eldridge Pkwy, Houston, TX 77079, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-7736-731e-984a-5f637038a82e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-7736-731e-984a-5f637038a82e",
        "storage_key": "property/6767906449166817/019d089b-7736-731e-984a-5f637038a82e.webp",
        "width": 1200,
        "height": 1200
      },
      "poi_business_url": "http://www.conocophillips.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17180807210887419194&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "conocophillips-world-headquarters---spirit-one",
      "poi_latitude": "29.7828955",
      "poi_longitude": "-95.6184225",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-293-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83fa-7479-9271-3e804dd5af25",
        "storage_key": "property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh9OZYZbbQIYROhVqZyF9bu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_da9706f0-1617-4c22-ab7c-4dcdab9a11e8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "custom",
      "poi_name": "Honeywell",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 CityWest Blvd, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-79af-75ed-a20d-36ed8465be4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d089b-79af-75ed-a20d-36ed8465be4d",
        "storage_key": "property/6767906449166817/019d089b-79af-75ed-a20d-36ed8465be4d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.honeywell.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4963438541816280246&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "honeywell",
      "poi_latitude": "29.74274059999999",
      "poi_longitude": "-95.5605024",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-252-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d089b-83fa-7479-9271-3e804dd5af25",
        "storage_key": "property/6767906449166817/019d089b-83fa-7479-9271-3e804dd5af25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyWdeRUzDQIYRtjRxbQ6t4UQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_5f490de1-a44e-45d6-8005-b85873492827",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_11e313fa-34ef-4e80-85b8-206e5b396181",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_432df0d6-e1dd-4c7c-9520-a303aee3d21a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_fd85320f-bf06-4dea-91c5-47df85c913fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_cf5b8871-3618-488a-87a3-d04c14da211d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_e762daa0-b648-43a0-8e2e-a79539b6a075",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_9a46c9be-9da1-44b3-b8c4-ede137522f06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "rating": "4",
      "name": "Jennifer Whittngton",
      "text": "I shout out to the security lady who knocked on the door last night 2/27/26 and told us my packages were delivered to a wrong apartment for 3 weeks 🤦🏾‍♀️. Anywho, I see you and appreciate you MIRACLES AND BLESSINGS 🙏🏾✝️🙏🏾\nI wanted to add I've lived here about 3 years or 4 years , 4 I think and I don't go to the office much or call very much but when we do myself or my son we're always treated with the same respect we show. Our concerns are addressed and we thank you for it I absolutely believe in being fair. MIRACLES AND BLESSINGS 🙏🏾✝️",
      "date": "2026-05-28",
      "title": "false"
    },
    {
      "id": "custom_44a2e37c-1005-4464-8b73-3b9dc62d7580",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "rating": "4",
      "name": "Catrina",
      "text": "Even though these apartments have gone through some changes, things are looking better.\nMs. Kelly is awesome and maintenance is the best, especially Alex G. Not only is he respectful but he is very knowledgeable at his job! He's fast and efficient!",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_ed243bb0-3491-498e-a9ee-e8a4021618a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "rating": "5",
      "name": "Derrick Allen (Hell Razzor)",
      "text": "Beautiful scenery nice Apartments",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_fb2484d6-c289-4cb5-86d6-02e2c03234cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "rating": "5",
      "name": "Aleighya Brown",
      "text": "This place is absolutely fantastic! The staff went above and beyond to make our move enjoyable, property manager is kind and caring and the maintenance team had everything in perfect working order. Truly a 5-star experience all around. Best property I have stayed at since I have moved to Houston",
      "date": "2026-04-10",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a54d0-e4a9-73a8-80f3-773544a89772",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-the-quinn-at-westchase",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817"
    },
    {
      "lead_collector_id": "019a9d10-4fa4-7072-9712-4caaa8263ab2",
      "lead_source": "LANDING_PAGE",
      "name": "rr-living-the-quinn-at-westchase-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-in-houston",
      "search_query": "luxury apartments with pool in Houston",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Houston",
      "h2_subtitle": "Discover ultimate comfort in our luxury apartments with a pool in Houston. Enjoy modern amenities and stylish living spaces at The Quinn at Westchase.",
      "page_copy": "Welcome to The Quinn at Westchase, your destination for luxury apartments with pool in Houston. Nestled in the vibrant Briar Forest neighborhood, our community offers a blend of style and convenience. Unwind by our refreshing pool, perfect for relaxation after a busy day in the city.\n\nOur one, two, and three-bedroom apartments come equipped with top-tier amenities including air conditioning, high-speed internet, and beautiful patios. Experience unparalleled living with on-site maintenance, modern dishwashers, and refrigerators in every unit. Schedule a tour today and see what luxury living is all about at The Quinn!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Houston",
      "seo_description": "Explore luxury apartments with pool at The Quinn at Westchase, Houston. Enjoy modern living with top amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "dog-park-apartments-near-briar-forest",
      "search_query": "dog park apartments near Briar Forest",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Near Briar Forest",
      "h2_subtitle": "Explore pet-friendly apartments with a dog park near Briar Forest. Ideal for pet lovers seeking modern living spaces at The Quinn at Westchase.",
      "page_copy": "At The Quinn at Westchase, we offer dog park apartments near Briar Forest, designed to accommodate both you and your furry friend. Our beautiful community features a dedicated dog park, providing a safe and fun environment for your pet to enjoy.\n\nLocated in the lively Briar Forest area, our spacious one, two, and three-bedroom apartments come with amenities such as high-speed internet, air conditioning, and private patios. Residents enjoy convenience with on-site maintenance, a refreshing pool, and a community lounge. Discover pet-friendly living in Houston, TX by scheduling a visit today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Near Briar Forest",
      "seo_description": "Find dog park apartments near Briar Forest at The Quinn. Enjoy pet-friendly living with modern amenities and a dedicated dog park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "air-conditioned-rentals-in-harris-county",
      "search_query": "air conditioned rentals in Harris County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Rentals in Harris County",
      "h2_subtitle": "Discover air conditioned rentals in Harris County at The Quinn at Westchase, offering cool comfort and modern amenities in every apartment.",
      "page_copy": "Experience the perfect blend of comfort and convenience at The Quinn at Westchase, where we offer air conditioned rentals in Harris County. If you're looking to beat the Texas heat, our apartments feature efficient air conditioning systems to keep you cool all year round. \n\nSituated in Houston’s vibrant Briar Forest neighborhood, our community provides a variety of spacious living options, from one to three-bedroom units. Residents enjoy amenities such as high-speed internet, a refreshing pool, and a relaxing community lounge. Join us at The Quinn and enjoy a cool, modern lifestyle!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Rentals in Harris County",
      "seo_description": "Explore air conditioned rentals at The Quinn in Harris County. Enjoy modern amenities and stay cool year-round in comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "houston-apartments-with-dishwasher",
      "search_query": "Houston apartments with dishwasher",
      "category": "Amenity",
      "h1_title": "Houston Apartments with Dishwasher",
      "h2_subtitle": "Find your ideal apartment at The Quinn with dishwashers in every unit. Experience modern living in Houston with top-notch amenities.",
      "page_copy": "Welcome to The Quinn at Westchase, where convenience meets comfort in our Houston apartments with dishwasher facilities. Each unit features a modern, efficient dishwasher, making clean-up a breeze so you can enjoy more leisure time.\n\nOur community resides in the dynamic Briar Forest neighborhood and offers beautifully designed one, two, and three-bedroom apartments. Residents can take advantage of other great amenities, including a refreshing pool, air conditioning, and high-speed internet. With maintenance on site, you can relax knowing we’ve got it all covered. Discover the ease of living at The Quinn today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Houston Apartments with Dishwasher",
      "seo_description": "Discover Houston apartments with dishwashers at The Quinn. Enjoy modern conveniences and stylish living spaces in our vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "high-speed-internet-apartments-houston-77077",
      "search_query": "high-speed internet apartments Houston 77077",
      "category": "Amenity",
      "h1_title": "High-Speed Internet Apartments in Houston 77077",
      "h2_subtitle": "Connect seamlessly with high-speed internet apartments in Houston's 77077 area at The Quinn. Enjoy fast and reliable connectivity.",
      "page_copy": "Stay connected at The Quinn at Westchase, offering high-speed internet apartments in Houston, 77077. We understand the importance of reliable internet, whether you're working from home, streaming your favorite shows, or staying in touch with loved ones. Our residences provide the connectivity you need with fast and dependable service.\n\nLocated in the bustling Briar Forest neighborhood, our community features modern one, two, and three-bedroom apartments with additional amenities such as a refreshing pool, air conditioning, and a fully-equipped kitchen with a dishwasher. Explore the convenience and comfort of living at The Quinn today, where staying connected is easier than ever!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High-Speed Internet Apartments in Houston 77077",
      "seo_description": "Find high-speed internet apartments in Houston 77077 at The Quinn. Enjoy fast, reliable internet speeds and modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-briar-forest",
      "search_query": "one bedroom apartments briar forest",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Briar Forest",
      "h2_subtitle": "Explore our stylish one bedroom apartments in Briar Forest at The Quinn. Experience modern living with top-tier amenities.",
      "page_copy": "Looking for one bedroom apartments in Briar Forest? The Quinn at Westchase offers spacious and contemporary options that cater to your lifestyle needs. Each apartment is designed with comfort in mind, providing residents with modern amenities like air conditioning and high-speed internet.\n\nNestled in the vibrant community of Briar Forest, The Quinn features not only the comfort of a cozy one-bedroom apartment but also a suite of community amenities. Enjoy lounging by the pool, utilizing the on-site maintenance services, or relaxing on the sundeck. Discover the ideal home for your Houston life at The Quinn today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Briar Forest",
      "seo_description": "Find stylish one bedroom apartments in Briar Forest at The Quinn. Experience modern amenities and a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-houston-tx",
      "search_query": "two bedroom apartments houston tx",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Houston, TX",
      "h2_subtitle": "Discover spacious two bedroom apartments in Houston, TX at The Quinn. Enjoy modern amenities and a prime location.",
      "page_copy": "Searching for two bedroom apartments in Houston, TX? The Quinn at Westchase presents beautifully designed two-bedroom homes that perfectly blend style and function. With amenities such as a fully-equipped kitchen featuring a dishwasher and air conditioning, these apartments cater to all your needs.\n\nOur community is situated in the lively Briar Forest area, offering residents a refreshing pool, a sundeck, and a dog park for your furry friends. With maintenance on site, you’ll enjoy a hassle-free living experience. Make The Quinn your new home and experience the best of Houston living today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Houston, TX",
      "seo_description": "Explore two bedroom apartments in Houston, TX at The Quinn. Enjoy spacious living with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-harris-county",
      "search_query": "three bedroom apartments near harris county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near Harris County",
      "h2_subtitle": "Find spacious three bedroom apartments near Harris County at The Quinn. Experience comfort and convenience in a modern setting.",
      "page_copy": "Discover the ideal living space with three bedroom apartments near Harris County at The Quinn at Westchase. These roomy, thoughtfully designed units provide ample space for families or those needing extra room. Equipped with conveniences such as high-speed internet, air conditioning, and a fully featured kitchen, we ensure all your needs are met.\n\nLocated in the vibrant Briar Forest area, our community offers access to excellent amenities including a refreshing pool, sundeck, and a dog park. With maintenance on site, residents enjoy a seamless, enjoyable living experience. Choose The Quinn and embrace spacious living close to Harris County today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near Harris County",
      "seo_description": "Explore three bedroom apartments near Harris County at The Quinn. Enjoy spacious living and modern amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "apartments-near-houston-christian-university",
      "search_query": "apartments near houston christian university",
      "category": "School",
      "h1_title": "Apartments Near Houston Christian University",
      "h2_subtitle": "Discover apartments near Houston Christian University at The Quinn. Enjoy convenient living with modern amenities just minutes away.",
      "page_copy": "Looking for apartments near Houston Christian University? The Quinn at Westchase offers an ideal location with easy access to the university, providing a perfect home for students and faculty alike. Each apartment comes equipped with modern amenities such as high-speed internet and air conditioning to ensure a comfortable living environment.\n\nSituated in the vibrant Briar Forest area, The Quinn offers a range of community amenities, including a sparkling pool, relaxing sundeck, and a welcoming dog park. With our on-site maintenance team, residents can enjoy a hassle-free living experience. Live close to the educational hub of Houston while enjoying a modern lifestyle at The Quinn today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Houston Christian University",
      "seo_description": "Find the perfect apartment near Houston Christian University at The Quinn. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "apartments-close-to-houston-city-college-alief-hayes-campus",
      "search_query": "apartments close to houston city college alief hayes campus",
      "category": "School",
      "h1_title": "Apartments Near Houston City College Alief Campus",
      "h2_subtitle": "Explore apartments close to Houston City College Alief Hayes Campus at The Quinn. Conveniently located for easy campus access.",
      "page_copy": "Searching for apartments close to Houston City College Alief Hayes Campus? The Quinn at Westchase offers the perfect proximity, making it an excellent choice for students and staff seeking convenience and comfort. Our apartments come equipped with features like high-speed internet and air conditioning, ensuring a comfortable living experience.\n\nLocated in Briar Forest, The Quinn provides residents with a suite of amenities, including a refreshing pool and a spacious sundeck. Additional conveniences such as a dog park and on-site maintenance ensure a seamless living experience. Embrace the ease of commuting to campus while enjoying a modern, stylish living space at The Quinn.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Houston City College Alief Campus",
      "seo_description": "Find apartments close to Houston City College Alief Hayes Campus at The Quinn. Enjoy modern living with easy campus access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "apartments-by-houston-community-college-spring-branch-campus",
      "search_query": "apartments by houston community college spring branch campus harris county",
      "category": "School",
      "h1_title": "Apartments by Houston Community College",
      "h2_subtitle": "Find ideal apartments by Houston Community College Spring Branch Campus in Harris County at The Quinn at Westchase.",
      "page_copy": "For those seeking apartments by Houston Community College Spring Branch Campus in Harris County, The Quinn at Westchase offers a convenient and modern living option. Located within easy reach of the campus, our community is perfect for students, faculty, and staff. Enjoy spacious living arrangements, complete with essential amenities like high-speed internet and air conditioning.\n\nNestled in the dynamic Briar Forest area, The Quinn provides additional perks such as a dog park, a relaxing sundeck, and a refreshing pool. With on-site maintenance, you can focus on studies or work while enjoying a hassle-free lifestyle. Experience the convenience of being near Houston Community College while enjoying all that The Quinn has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Houston Community College Spring Branch",
      "seo_description": "Discover apartments by Houston Community College Spring Branch Campus in Harris County at The Quinn. Enjoy modern living close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "apartments-near-memorial-hermann-southwest-hospital",
      "search_query": "apartments near Memorial Hermann Southwest Hospital Houston",
      "category": "Hospital",
      "h1_title": "Apartments Near Memorial Hermann Southwest",
      "h2_subtitle": "Explore apartments near Memorial Hermann Southwest Hospital in Houston at The Quinn, offering comfort and modern amenities just minutes away.",
      "page_copy": "Looking for apartments near Memorial Hermann Southwest Hospital in Houston? The Quinn at Westchase presents an excellent option for those who need convenience and comfort close to work. Our spacious one, two, or three-bedroom units provide a pleasant living environment with key amenities such as air conditioning and high-speed internet.\n\nSituated in the pleasant Briar Forest area, The Quinn offers residents access to a variety of community features, including a sparkling pool, a dog park, and a peaceful sundeck. With on-site maintenance available, residents can enjoy a seamless living experience. Choose The Quinn for a convenient commute to Memorial Hermann Southwest Hospital and enjoy modern living in Houston.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Memorial Hermann Southwest Hospital",
      "seo_description": "Find spacious apartments near Memorial Hermann Southwest Hospital in Houston at The Quinn. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "houston-apartments-close-to-hca-houston-healthcare-west",
      "search_query": "Houston apartments close to HCA Houston Healthcare West",
      "category": "Hospital",
      "h1_title": "Houston Apartments Near HCA Healthcare West",
      "h2_subtitle": "Discover Houston apartments close to HCA Healthcare West at The Quinn. Enjoy modern amenities and a convenient location.",
      "page_copy": "If you're searching for Houston apartments close to HCA Houston Healthcare West, The Quinn at Westchase is a perfect choice. Located in the vibrant Briar Forest neighborhood, our community provides a comfortable and modern living experience tailored for professionals and families alike. Choose from a selection of spacious one, two, or three-bedroom apartments equipped with high-speed internet and air conditioning for optimal comfort.\n\nBeyond the doorstep, enjoy a plethora of amenities designed for relaxation and convenience, including a sparkling pool, a sundeck, and a dog park. On-site maintenance ensures a worry-free living environment, allowing you to focus on your work at HCA Houston Healthcare West. Experience the ease of living close to your workplace while relishing in all the comforts The Quinn provides.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Houston Apartments Near HCA Healthcare West",
      "seo_description": "Find Houston apartments close to HCA Houston Healthcare West at The Quinn. Modern living with convenient access to healthcare facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "apartments-near-camden-park-westchase-houston",
      "search_query": "apartments near Camden Park Westchase Houston",
      "category": "Park",
      "h1_title": "Apartments Near Camden Park Westchase",
      "h2_subtitle": "Explore The Quinn's apartments near Camden Park in Westchase, Houston, offering a blend of modern amenities and a prime location.",
      "page_copy": "For those seeking apartments near Camden Park in Westchase, Houston, The Quinn at Westchase offers an exceptional living community. Located in the lively Briar Forest area, our apartments provide easy access to Camden Park and a host of local amenities. Choose from our spacious one, two, or three-bedroom layouts, each featuring modern conveniences like high-speed internet and air conditioning.\n\nResidents at The Quinn can enjoy amenities designed to enhance their lifestyle, such as a sparkling pool, a well-kept dog park, and a sunlit sundeck. With maintenance services conveniently on-site, residents can focus on enjoying their home and community. Discover the ideal balance of leisure and practicality in a location that places you close to Camden Park in Westchase, Houston.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Camden Park Westchase Houston",
      "seo_description": "Find modern apartments near Camden Park in Westchase, Houston at The Quinn. Enjoy excellent amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "living-close-to-arthur-storey-park-briar-forest",
      "search_query": "living close to Arthur Storey Park Briar Forest",
      "category": "Park",
      "h1_title": "Living Close to Arthur Storey Park",
      "h2_subtitle": "Experience the benefits of living close to Arthur Storey Park in Briar Forest at The Quinn. Enjoy both convenience and comfort.",
      "page_copy": "Imagine living close to Arthur Storey Park in the heart of Briar Forest, where relaxation and recreation are just steps away. The Quinn at Westchase offers the perfect residence for those who appreciate proximity to nature without sacrificing modern comforts. Choose from our thoughtfully designed one, two, or three-bedroom apartments, all equipped with high-speed internet and air conditioning.\n\nEnhance your lifestyle with The Quinn's superb community amenities, including a refreshing pool, a dedicated dog park, and relaxing sundeck spaces. Our on-site maintenance ensures a hassle-free living experience, so you can fully enjoy the nearby Arthur Storey Park and its scenic walking trails. Live at The Quinn and find the balance of nature and modern living right at your doorstep in Briar Forest.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Arthur Storey Park in Briar Forest",
      "seo_description": "Experience modern living close to Arthur Storey Park in Briar Forest at The Quinn. Enjoy nature and convenience in one location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "bayland-park-nearby-apartments-harris-county",
      "search_query": "Bayland Park nearby apartments in Harris County",
      "category": "Park",
      "h1_title": "Bayland Park Nearby Apartments",
      "h2_subtitle": "Discover apartments near Bayland Park in Harris County. The Quinn offers a blend of comfort and convenience.",
      "page_copy": "Looking for Bayland Park nearby apartments in Harris County? The Quinn at Westchase is perfectly situated to offer both comfort and proximity to this beloved recreational area. Nestled within the vibrant Briar Forest neighborhood, our community provides easy access to the natural beauty of Bayland Park while ensuring all the modern amenities you need are right at home. Choose from our spacious one, two, or three-bedroom floor plans, featuring essentials like high-speed internet and air conditioning.\n\nOur residents enjoy an array of conveniences, including a stunning pool, a vibrant dog park, and a relaxing sundeck. The on-site maintenance ensures that living at The Quinn remains worry-free, allowing you to spend more time enjoying the nearby Bayland Park's facilities. Experience the ideal combination of local park access and a well-appointed residence at The Quinn at Westchase in Harris County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bayland Park Nearby Apartments, Harris County",
      "seo_description": "Find Bayland Park nearby apartments in Harris County at The Quinn. Modern living and park access in one community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "nearby-alief-community-park-rentals-77077",
      "search_query": "nearby Alief Community Park rentals zip code 77077",
      "category": "Park",
      "h1_title": "Rentals Near Alief Community Park",
      "h2_subtitle": "Discover rentals near Alief Community Park in the 77077 zip code. The Quinn offers prime location and amenities.",
      "page_copy": "Searching for rentals nearby Alief Community Park in the 77077 zip code? The Quinn at Westchase offers an ideal location with the convenience of being close to this popular community area. Located in the bustling Briar Forest neighborhood, our apartments provide the perfect combination of convenience and comfort with easy access to Alief Community Park. We offer spacious one, two, and three-bedroom options, each equipped with modern conveniences like air conditioning and high-speed internet.\n\nAt The Quinn, residents enjoy premium amenities, including a refreshing pool and a spacious dog park, perfect for pet owners. The on-site maintenance ensures that your living experience is seamless and worry-free, allowing you to take full advantage of the proximity to Alief Community Park. Discover modern living paired with the perfect location at The Quinn at Westchase, where community and comfort come together.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Alief Community Park in 77077",
      "seo_description": "Find nearby rentals to Alief Community Park in the 77077 area at The Quinn. Enjoy comfort and prime location with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166817",
      "source": "generator",
      "page_item_url": "apartments-by-terry-hershey-park-houston-tx",
      "search_query": "apartments by Terry Hershey Park Houston TX",
      "category": "Park",
      "h1_title": "Apartments by Terry Hershey Park",
      "h2_subtitle": "Explore apartments by Terry Hershey Park in Houston, TX. The Quinn offers ideal living for nature enthusiasts.",
      "page_copy": "Looking for apartments by Terry Hershey Park in Houston, TX? The Quinn at Westchase offers an unparalleled living experience with proximity to this beautiful haven. Situated in the vibrant Briar Forest area, The Quinn ensures you're never far from the stunning trails and natural scenery of Terry Hershey Park. Our community provides spacious one, two, and three-bedroom apartments, all equipped with essentials like air conditioning and high-speed internet to meet your modern living needs.\n\nResidents at The Quinn enjoy top-tier amenities, including a luxurious pool, a well-maintained dog park, and a relaxing sundeck. Our dedicated on-site maintenance team ensures a hassle-free experience, so you can fully indulge in the outdoor activities that Terry Hershey Park offers. Discover the joys of living close to nature while enjoying the comforts of home at The Quinn at Westchase in Houston, TX.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Terry Hershey Park, Houston TX",
      "seo_description": "Find ideal apartments by Terry Hershey Park in Houston, TX at The Quinn. Enjoy nature and luxury living combined.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5596"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18348980588"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5586676"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NBRZXLGL"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "832-230-2672"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "832-843-1284"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "832-662-5921"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "832-510-8533"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "832-639-6108"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "832-789-6453"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "832-551-2531"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "832-501-2283"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "832-979-0468"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "832-957-0797"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "832-734-8526"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "832-536-7689"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "832-243-7405"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "832-957-0709"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "832-905-8941"
    },
    {
      "ID": "custom_knock_psocl_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=psocl"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "832-281-5187"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "832-979-1384"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_knock_psocl_title",
      "type": "STRING",
      "value": "Paid Social"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "43833693005"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "832-412-4968"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "832-261-7606"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "327158ed76b11f02"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "832-662-2402"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_psocl_number",
      "type": "STRING",
      "value": "832-802-7487"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "832-843-2053"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "832-990-9378"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "832-626-1766"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "832-730-2457"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "832-906-4142"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "832-240-5413"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.thequinnatwestchase.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "832-861-0778"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "832-957-0797"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "5596",
  "custom_repli_id": "18348980588",
  "custom_realpage_id": "5586676",
  "custom_knock_a_link": "https://www.thequinnatwestchase.com?utm_knock=a",
  "custom_knock_g_link": "https://www.thequinnatwestchase.com?utm_knock=g",
  "custom_knock_r_link": "https://www.thequinnatwestchase.com?utm_knock=r",
  "custom_knock_w_link": "https://www.thequinnatwestchase.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-NBRZXLGL",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.thequinnatwestchase.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.thequinnatwestchase.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.thequinnatwestchase.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.thequinnatwestchase.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.thequinnatwestchase.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.thequinnatwestchase.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "832-230-2672",
  "custom_knock_ads_link": "https://www.thequinnatwestchase.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.thequinnatwestchase.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "832-843-1284",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.thequinnatwestchase.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.thequinnatwestchase.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.thequinnatwestchase.com?utm_knock=ppn",
  "custom_knock_r_number": "832-662-5921",
  "custom_knock_w_number": "832-510-8533",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "832-639-6108",
  "custom_knock_amap_link": "https://www.thequinnatwestchase.com?utm_knock=amap",
  "custom_knock_ar_number": "832-789-6453",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "832-551-2531",
  "custom_knock_fb_number": "832-501-2283",
  "custom_knock_fl_number": "832-979-0468",
  "custom_knock_gp_number": "832-957-0797",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.thequinnatwestchase.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "832-734-8526",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.thequinnatwestchase.com?utm_knock=bcard",
  "custom_knock_bnr_number": "832-536-7689",
  "custom_knock_cfres_link": "https://www.thequinnatwestchase.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "832-243-7405",
  "custom_knock_lgp_number": "832-957-0709",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.thequinnatwestchase.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "832-905-8941",
  "custom_knock_psocl_link": "https://www.thequinnatwestchase.com?utm_knock=psocl",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "832-281-5187",
  "custom_knock_bandit_link": "https://www.thequinnatwestchase.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.thequinnatwestchase.com?utm_knock=flyers",
  "custom_knock_osoc_number": "832-979-1384",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_knock_psocl_title": "Paid Social",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "43833693005",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "832-412-4968",
  "custom_knock_cfres_number": "832-261-7606",
  "custom_knock_chatgpt_link": "https://www.thequinnatwestchase.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "327158ed76b11f02",
  "custom_knock_dirmail_link": "https://www.thequinnatwestchase.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "832-662-2402",
  "custom_knock_propbro_link": "https://www.thequinnatwestchase.com?utm_knock=propbro",
  "custom_knock_psocl_number": "832-802-7487",
  "custom_knock_bandit_number": "832-843-2053",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "832-990-9378",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.thequinnatwestchase.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "832-626-1766",
  "custom_knock_dirmail_number": "832-730-2457",
  "custom_knock_propbro_number": "832-906-4142",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "832-240-5413",
  "custom_knock_maintenance_link": "https://www.thequinnatwestchase.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_knock_maintenance_number": "832-861-0778",
  "custom_ppc_tracking_phone_number": "832-957-0797"
};

export const generatedAt = '2026-10-07T17:13:17.966Z';
